import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComponentsModule } from '../shared/components/components.module';

import { DonationRoutingModule} from './donation-routing.module';

import { DonationComponent } from './donation.component';


@NgModule({
  declarations: [
    DonationComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    DonationRoutingModule,
  ]
})
export class DonationModule { }
